export default function CTASection() {
  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 relative bg-background-100 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Bright%20airy%20walk-in%20closet%20with%20organized%20clothing%20racks%20featuring%20neutral%20toned%20outfits%2C%20warm%20natural%20window%20light%2C%20luxury%20interior%20design%2C%20minimalist%20aesthetic%2C%20clean%20organization%2C%20modern%20home%20lifestyle%2C%20editorial%20quality&width=960&height=700&seq=v2-cta-left&orientation=landscape"
              alt="Best Mulebuy Spreadsheet"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-black/15"></div>
          <div className="relative z-10 flex flex-col justify-end p-10 md:p-16 h-full min-h-[350px] md:min-h-[450px]">
            <span className="text-xs font-label tracking-widest text-background-200/80 uppercase mb-3">Resources</span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-none">
              <span className="block">Best</span>
              <span className="block">Mulebuy</span>
              <span className="block">Spreadsheet</span>
            </h2>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center p-10 md:p-16 min-h-[350px] md:min-h-[450px]">
          <div className="max-w-md text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
              Get Access to the Ultimate Database
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-sm mx-auto">
              Ready to explore the most comprehensive <strong>mulebuy spreadsheet</strong> collection? Visit our main platform now and start browsing thousands of curated product listings across all categories.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Access Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}